
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './SingleVideo.css';
import axios from 'axios';
import { Video } from '../../importCL';
import useSingleYoutubeVideo from '../../hooks/useYoutubeSingleVideo';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper';

interface ISingleVideoProps extends MappedComponentProperties {
    videoLink?: string;
    mobileImgPath?: string;
    videoSize?: string;
    videoLinkCall?: string;
    videoTitle?: string;
}

export const SingleVideoEditConfig = {
    emptyLabel: 'SingleVideo',
    isEmpty: (props: PropsWithChildren<ISingleVideoProps>) => {
        return !props || !props.videoLink;
    },
};

interface VideoData {
    snippet: {
        title: string,
        description: string,
        publishedAt: string,
        thumbnails: {
            default: {
                url: string,
                width: number,
                height: number
            },
            medium: {
                url: string,
                width: number,
                height: number
            },
            high: {
                url: string,
                width: number,
                height: number
            },
        }
    },
    id: string,
    contentDetails : {
        duration: string,
    },
}

const SingleVideo = (props: PropsWithChildren<ISingleVideoProps>): JSX.Element => {
    const { VideoElement, videoData } = useSingleYoutubeVideo({ youtubeUrl: props.videoLink });

    return (
        <div id='single-video' className='SingleVideo'>
            <div className={`${props.videoSize ? props.videoSize : ''} single_video__video`}>
                {props.videoLink && (
                    <div className='aspect_ratio'>
                        <VideoElement
                            titleFallback={props.videoTitle || videoData?.snippet?.title || ''}
                            thumbnailOverride={props.mobileImgPath}
                            descriptionFallback={videoData?.snippet?.description || ''}
                            uploadDateFallback={videoData?.snippet?.publishedAt || ''}
                            videoDisclaimer={<p className='ytdisclaimer mt-6'>Credit One Bank uses YouTube API services and by watching the video, you are agreeing to the YouTube Terms of Service (<LinkWrapper target={'_self'} href={'https://youtube.com/terms'}>https://youtube.com/terms</LinkWrapper>) and Google Privacy Policy (<LinkWrapper target={'_self'} href={'https://www.google.com/policies/privacy'}>https://www.google.com/policies/privacy</LinkWrapper>).</p>}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default SingleVideo;
